import Vue from 'vue';

export default ({ subject }) => {
    const roles = ['moderator', 'platform-owner', 'cmnty'];

    return subject ? roles.includes(subject.role.type) : Vue.authorizationChecker.isGranted('role-moderator');
};
